import Link from "next/link";
import { useRouter } from "next/router";
import { FC } from "react";
import { LEGAL_PAGES } from "../../lib/legalDocuments";

const LegalNav: FC = () => {
  const { pathname } = useRouter();

  return (
    <nav
      aria-label="Youdle policies"
      className="mb-6 flex flex-wrap justify-center gap-x-6 gap-y-2 border-b border-gray-400 pb-4 text-sm"
    >
      {LEGAL_PAGES.map((page) => {
        const isCurrent = pathname === page.href;

        return (
          <Link
            key={page.href}
            href={page.href}
            aria-current={isCurrent ? "page" : undefined}
            className={
              isCurrent
                ? "font-bold text-black underline"
                : "font-medium text-black transition-colors duration-300 hover:text-red-600 hover:underline"
            }
          >
            {page.label}
          </Link>
        );
      })}
    </nav>
  );
};

export default LegalNav;
